import { z } from "zod";
import { appIdSchema, isoTimestampSchema, runIdSchema, usageEventIdSchema, } from "./identifiers.js";
const tokenCountSchema = z.number().int().nonnegative();
export const agentUsageSchema = z
    .object({
    schemaVersion: z.literal(1),
    usageEventId: usageEventIdSchema,
    appId: appIdSchema,
    runId: runIdSchema,
    childRunId: runIdSchema.nullable(),
    provider: z.string().trim().min(1).max(100),
    model: z.string().trim().min(1).max(200),
    source: z.enum(["provider", "engine"]),
    inputTokens: tokenCountSchema.nullable(),
    cachedInputTokens: tokenCountSchema.nullable(),
    outputTokens: tokenCountSchema.nullable(),
    reasoningTokens: tokenCountSchema.nullable(),
    totalTokens: tokenCountSchema.nullable(),
    observedAt: isoTimestampSchema,
})
    .strict()
    .superRefine((value, context) => {
    const parts = [
        value.inputTokens,
        value.cachedInputTokens,
        value.outputTokens,
        value.reasoningTokens,
    ].filter((part) => part !== null);
    if (value.totalTokens === null && parts.length === 0) {
        context.addIssue({
            code: "custom",
            message: "Provider-reported usage must contain at least one token count",
        });
    }
    if (value.totalTokens !== null &&
        value.inputTokens !== null &&
        value.outputTokens !== null &&
        value.totalTokens < value.inputTokens + value.outputTokens) {
        context.addIssue({
            code: "custom",
            message: "totalTokens cannot be less than inputTokens plus outputTokens",
        });
    }
});
/**
 * Returns the provider's canonical total when available. Adapter component
 * fields do not have identical inclusion semantics across providers (for
 * example, cached input may be a subset or a separate count), so they must not
 * be added to a reported total.
 */
export function agentUsageTokenCount(usageValue) {
    const usage = agentUsageSchema.parse(usageValue);
    if (usage.totalTokens !== null)
        return usage.totalTokens;
    const inputAndOutput = (usage.inputTokens ?? 0) + (usage.outputTokens ?? 0);
    if (inputAndOutput > 0)
        return inputAndOutput;
    return (usage.cachedInputTokens ?? 0) + (usage.reasoningTokens ?? 0);
}
//# sourceMappingURL=usage.js.map